/**
 * Calendar roles used by the weekly Production Calendar's "View by Role" filter.
 *
 * Strings intentionally match the values that drive `CrewGroup.section` (set in
 * `CrewScheduleStore.mapToCrewGroups`) and the `sectionOrder` input on the
 * production calendar. Keeping them identical lets us compose the role filter
 * against the rendered group sections without any translation layer.
 *
 * Note: this is distinct from the user-permission `CALENDAR_ROLES` in
 * `roles.model.ts`, which gates access to the calendar feature itself.
 */
export type CalendarRole = 'Foreman' | 'Sub-Contractor' | 'Co-Foreman' | 'Field Superintendent';

/**
 * All selectable roles in display order. "Foreman" is listed first and is the
 * default-selected role on a fresh session — see `CalendarService` defaults.
 */
export const CALENDAR_ROLES: readonly CalendarRole[] = [
  'Foreman',
  'Sub-Contractor',
  'Co-Foreman',
  'Field Superintendent',
] as const;

/**
 * Default-selected roles on a fresh session: regular foremen visible, sectioned
 * roles (Co-Foreman / Field Superintendent) hidden until explicitly selected.
 */
export const DEFAULT_CALENDAR_ROLES: readonly CalendarRole[] = ['Foreman'] as const;
